__webpack_require__.p = "/assets/turbo/1fe37173/universalat/_next/";